var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIconModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.31179 0.310343C0.689716 -0.0658303 1.28111 -0.100028 1.69785 0.20775L1.81724 0.310343L11 9.45001L20.1828 0.310343C20.5607 -0.0658303 21.1521 -0.100028 21.5688 0.20775L21.6882 0.310343C22.0661 0.686516 22.1005 1.27516 21.7913 1.68997L21.6882 1.80881L11.7527 11.6982C11.3748 12.0744 10.7834 12.1086 10.3667 11.8008L10.2473 11.6982L0.31179 1.80881C-0.10393 1.39502 -0.10393 0.724133 0.31179 0.310343Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6882 21.6897C21.3103 22.0658 20.7189 22.1 20.3022 21.7922L20.1828 21.6897L11 12.55L1.81724 21.6897C1.43932 22.0658 0.847922 22.1 0.431183 21.7922L0.31179 21.6897C-0.0661365 21.3135 -0.100494 20.7248 0.208719 20.31L0.31179 20.1912L10.2473 10.3018C10.6252 9.92564 11.2166 9.89144 11.6333 10.1992L11.7527 10.3018L21.6882 20.1912C22.1039 20.605 22.1039 21.2759 21.6882 21.6897Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconModal);
export default __webpack_public_path__ + "static/media/x-icon-modal.46783c922c837bb0295e4a49b6476736.svg";
export { ForwardRef as ReactComponent };